import { z } from 'zod';
import { INVITABLE_ROLES, ROLES } from '../constants.js';
import { emailSchema, uuidSchema } from './common.js';
export const acceptInviteSchema = z.object({
    token: z.string().min(20).max(200),
});
export const acceptInviteResponseSchema = z.object({
    workspaceId: z.string().uuid(),
    workspaceName: z.string(),
    role: z.enum(INVITABLE_ROLES),
});
export const memberSchema = z.object({
    userId: uuidSchema,
    fullName: z.string(),
    email: z.string().nullable(),
    avatarUrl: z.string().nullable(),
    role: z.enum(ROLES),
    isActive: z.boolean(),
    isSelf: z.boolean(),
    // Assigned locations for this member; always present, empty means access to all locations.
    locationIds: z.array(uuidSchema),
});
export const updateMemberRoleSchema = z.object({
    role: z.enum(INVITABLE_ROLES),
});
// Empty array means access to all locations.
export const memberLocationsUpdateSchema = z.object({
    locationIds: z.array(uuidSchema).max(50),
});
export const transferOwnershipSchema = z.object({
    toUserId: uuidSchema,
});
export const createInviteSchema = z.object({
    email: emailSchema,
    role: z.enum(INVITABLE_ROLES).default('installer'),
});
export const inviteSchema = z.object({
    id: uuidSchema,
    email: z.string(),
    role: z.enum(INVITABLE_ROLES),
    expiresAt: z.string(),
    createdAt: z.string(),
});
export const invitePreviewSchema = z.object({
    status: z.enum(['valid', 'expired', 'revoked', 'accepted', 'not_found']),
    email: z.string().nullable(),
    workspaceName: z.string().nullable(),
    role: z.enum(INVITABLE_ROLES).nullable(),
});
//# sourceMappingURL=members.js.map